import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { backendImageUrl, RoutesPaths } from "../Router/constant";
import Modal from "react-bootstrap/Modal";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import {
  approvedStoreAction,
  storeDetails,
  storeListDeleteAction,
} from "../actions/store";

export default function Stors() {
  const actionRef = useRef(null);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const { storeList, storeListLoader } = useSelector((state) => state.store);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const limit = 10;
  const [isStoreId, setIsStoreId] = useState();
  const [openActionId, setOpenActionId] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (actionRef.current && !actionRef.current.contains(e.target)) {
        setOpenActionId(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      dispatch(storeDetails(search, page, limit));
    }, 500);

    return () => clearTimeout(delay);
  }, [dispatch, search, page]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [storeList]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("sv-SE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const totalPages = storeList?.pagination?.totalPages || 1;
  const handleSearch = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };

  const handleEdit = (id) => {
    setIsStoreId(id);
    navigate(RoutesPaths.EDITSTORS.replace(":id", id), {});
  };

  const handleDelete = (id) => {
    setIsStoreId(id);
    setShow(true);
  };

  const handleConfirmDelete = async () => {
    const resp = await dispatch(storeListDeleteAction(isStoreId));
    if (resp.status === 200) {
      dispatch(storeDetails(search, page, limit)); // ✅ dispatch it
      setShow(false);
    } else {
      setShow(false);
    }
  };

  const viewShop = (shopId) => {
    navigate(RoutesPaths.VIEWSTORS.replace(":id", shopId), {});
  };

  const getPagination = (page, totalPages) => {
    const pages = [];

    // Always show first page
    pages.push(1);

    // Left dots
    if (page > 2) {
      pages.push("...");
    }

    // Current & next page
    if (page > 1 && page < totalPages) {
      pages.push(page);
    }

    if (page + 1 < totalPages) {
      pages.push(page + 1);
    }

    // Right dots
    if (page + 2 < totalPages) {
      pages.push("...");
    }

    // Always show last page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return [...new Set(pages)];
  };

  const [isApprovedModal, setIsApprovedModal] = useState(false);

  const approvedModalClose = () => {
    setIsApprovedModal(false);
  };

  const approvedStore = async (id) => {
    setIsStoreId(id);
    setIsApprovedModal(true);
  };
  const handleApprovedAccount = async () => {
    setActionLoading(true);

    const payload = { action: "approve" };
    const resp = await dispatch(approvedStoreAction(isStoreId, payload));

    if (resp.status === 200) {
      dispatch(storeDetails(search, page, limit));
    }

    setActionLoading(false);
    setIsApprovedModal(false);
  };

  const [isRejectedModal, setIsRejecteddModal] = useState(false);

  const rejectedModalClose = () => {
    setIsRejecteddModal(false);
  };

  const rejectedStore = async (id) => {
    setIsStoreId(id);
    setIsRejecteddModal(true);
  };

  const handleRejectedAccount = async () => {
    setActionLoading(true);

    const payload = { action: "reject" };
    const resp = await dispatch(approvedStoreAction(isStoreId, payload));

    if (resp.status === 200) {
      dispatch(storeDetails(search, page, limit));
    }

    setActionLoading(false);
    setIsRejecteddModal(false);
  };

  return (
    <>
      {storeListLoader ? (
        <div className="container-fluid contactSkeleton">
          {[...Array(6)].map((_, i) => (
            <ContentLoader key={i} width="100%" height={50}>
              <rect x="0" y="0" rx="5" ry="5" width="100%" height="50" />
            </ContentLoader>
          ))}
        </div>
      ) : (
        <div className="container-fluid mainConatinerSection">
          <div className="card card-flush">
            <div className="card-header align-items-center py-5 gap-2 gap-md-5">
              <div className="card-title">
                <div className="d-flex align-items-center position-relative my-1">
                  <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-4">
                    <span className="path1 searchPath"></span>
                    <span className="path2 searchPath"></span>
                  </i>
                  <input
                    ref={inputRef}
                    type="text"
                    className="form-control form-control-solid w-250px ps-12"
                    placeholder="Search store"
                    value={search}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <div className="card-toolbar">
                <Link to={RoutesPaths.ADDSTORS} className="btn buttonPrimary">
                  Add Store
                </Link>
              </div>
            </div>
            <div className="card-body pt-0 overFlowScroll">
              <table className="table align-middle table-row-dashed fs-6 gy-5">
                <thead>
                  <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                    <th className="categoryWidth">Store</th>
                    <th className="text-center min-w-150px">Email</th>
                    <th className="text-center">Created Date</th>
                    <th className="text-center">Approved</th>
                    <th className="text-center min-w-70px">Actions</th>
                  </tr>
                </thead>
                <tbody className="fw-semibold text-gray-600">
                  {storeList?.data?.length > 0 ? (
                    storeList.data.map((item, index) => (
                      <tr key={item._id || index}>
                        <td className="categoryWidth">
                          <div className="d-flex align-items-center">
                            <Link to="#" className="symbol symbol-50px">
                              <span
                                className="symbol-label"
                                style={{
                                  backgroundImage: `url(${backendImageUrl + item?.mainImage?.fileName
                                    })`,
                                }}
                              />
                            </Link>

                            <div className="ms-5">
                              <div
                                className="text-gray-800 text-hover-primary fs-5 fw-bold mb-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => viewShop(item._id)}
                              >
                                {item.shopName}
                              </div>
                              <div className="text-muted fs-7 fw-bold limitLineCss">
                                {item?.contact?.website}
                              </div>
                            </div>
                          </div>
                        </td>

                        <td className="text-center">{item?.contact?.email}</td>

                        <td className="text-center">
                          {formatDate(item.createdAt)}
                        </td>

                        <td className="text-center">
                          {item?.isRejected ? (
                            <div className="badge badge-light-danger">
                              Rejected
                            </div>
                          ) : item?.isApproved ? (
                            <div className="badge badge-light-success">
                              Approved
                            </div>
                          ) : (
                            <div className="badge badge-light-warning">
                              Pending
                            </div>
                          )}
                        </td>

                        <td className="text-center">
                          <div
                            ref={actionRef}
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div
                              className="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary"
                              onClick={() =>
                                setOpenActionId((prev) =>
                                  prev === item._id ? null : item._id,
                                )
                              }
                            >
                              Actions
                              <i className="ki-duotone ki-down fs-5 ms-1"></i>
                            </div>

                            {openActionId === item._id && (
                              <div className="menuActionSheet">
                                {!item?.isApproved && !item?.isRejected && (
                                  <>
                                    <div className="menu-item px-3">
                                      <div
                                        className="menu-link px-3"
                                        onClick={() => {
                                          approvedStore(item._id);
                                          setOpenActionId(null);
                                        }}
                                      >
                                        Approve
                                      </div>
                                    </div>

                                    <div className="menu-item px-3">
                                      <div
                                        className="menu-link px-3"
                                        onClick={() => {
                                          rejectedStore(item._id);
                                          setOpenActionId(null);
                                        }}
                                      >
                                        Reject
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div className="menu-item px-3">
                                  <div
                                    className="menu-link px-3"
                                    onClick={() => {
                                      handleEdit(item._id);
                                      setOpenActionId(null);
                                    }}
                                  >
                                    Edit
                                  </div>
                                </div>

                                <div className="menu-item px-3">
                                  <div
                                    className="menu-link px-3"
                                    onClick={() => {
                                      handleDelete(item._id);
                                      setOpenActionId(null);
                                    }}
                                  >
                                    Delete
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-5 text-muted">
                        No stores found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              {storeList?.data?.length > 0 && (
                <div className="row mt-4">
                  <div className="col-md-5">
                    <strong>Total: {storeList?.pagination?.total}</strong>
                  </div>

                  <div className="col-md-7 d-flex justify-content-end">
                    <ul className="pagination">
                      {/* Prev */}
                      {page > 1 && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => setPage(page - 1)}
                          >
                            Prev
                          </button>
                        </li>
                      )}

                      {getPagination(page, totalPages).map((item, index) => (
                        <li
                          key={index}
                          className={`page-item ${item === page ? "activePagination" : ""
                            } ${item === "..." ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            disabled={item === "..."}
                            onClick={() => item !== "..." && setPage(item)}
                          >
                            {item}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      {page < totalPages && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => setPage(page + 1)}
                          >
                            Next
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}
              {/* End Pagination */}
            </div>
          </div>
        </div>
      )}

      <Modal show={show} onHide={handleClose}>
        <div className="LogoutSection">
          <h6 className="m-0">Delete</h6>
          <p className="m-0">Are you sure you want to delete this store?</p>
          <div className="logoutbuttonSection">
            <button
              className="redButton fontBthSize"
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              className="greenButton fontBthSize"
              variant="primary"
              onClick={handleConfirmDelete}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      <Modal show={isApprovedModal} onHide={approvedModalClose}>
        <div className="LogoutSection">
          <h6 className="m-0">Approved account</h6>
          <p className="m-0">Are you sure you want to approved this store?</p>
          <div className="logoutbuttonSection">
            <button
              className="redButton fontBthSize fixed-btn"
              variant="secondary"
              onClick={approvedModalClose}
            >
              Close
            </button>
            <button
              className="greenButton fontBthSize fixed-btn d-flex align-items-center justify-content-center"
              onClick={handleApprovedAccount}
              disabled={actionLoading}
            >
              {actionLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Processing...
                </>
              ) : (
                "Confirm"
              )}
            </button>
          </div>
        </div>
      </Modal>

      <Modal show={isRejectedModal} onHide={rejectedModalClose}>
        <div className="LogoutSection">
          <h6 className="m-0">Rejected account</h6>
          <p className="m-0">Are you sure you want to rejected this store?</p>
          <div className="logoutbuttonSection">
            <button
              className="redButton fontBthSize fixed-btn"
              variant="secondary"
              onClick={rejectedModalClose}
            >
              Close
            </button>
            <button
              className="greenButton fontBthSize fixed-btn d-flex align-items-center justify-content-center"
              onClick={handleRejectedAccount}
              disabled={actionLoading}
            >
              {actionLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Processing...
                </>
              ) : (
                "Confirm"
              )}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
